import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PageBreadcrumbComponent } from '../../../shared/components/common/page-breadcrumb/page-breadcrumb.component';
import { ScheduledJobApiService } from '../../../shared/services/scheduled-job-api.service';
import { ScheduledJobConfigResponse, ScheduledJobExecutionResponse, scheduledJobExecutionStatusLabel } from '../../../shared/models/scheduled-job.model';

const JOB_KEY = 'currency.update-rates';

@Component({
  selector: 'app-currency-job-executions',
  standalone: true,
  imports: [CommonModule, FormsModule, PageBreadcrumbComponent],
  templateUrl: './currency-job-executions.component.html',
})
export class CurrencyJobExecutionsComponent implements OnInit {
  executions: ScheduledJobExecutionResponse[] = [];
  jobs: ScheduledJobConfigResponse[] = [];
  selectedJobId: number | null = null;
  loading = false;
  error = '';
  currentPage = 0;
  totalPages = 0;

  filterStatus = '';

  constructor(private scheduledJobApi: ScheduledJobApiService) {}

  ngOnInit(): void {
    this.loadJobs();
  }

  loadJobs(): void {
    this.scheduledJobApi.list(JOB_KEY).subscribe({
      next: (data) => {
        this.jobs = data ?? [];
        if (this.jobs.length > 0) {
          this.selectedJobId = this.jobs[0].id;
          this.loadExecutions(0);
        }
      },
      error: () => {},
    });
  }

  loadExecutions(page = 0): void {
    if (this.selectedJobId == null) return;
    this.loading = true;
    this.error = '';
    this.scheduledJobApi.getExecutions(this.selectedJobId, page).subscribe({
      next: (data) => {
        let content = data.content ?? [];
        if (this.filterStatus) {
          content = content.filter((e) => e.status === this.filterStatus);
        }
        this.executions = content;
        this.currentPage = data.page ?? page;
        this.totalPages = data.totalPages ?? 1;
        this.loading = false;
      },
      error: () => {
        this.error = 'Error al cargar el historial.';
        this.loading = false;
      },
    });
  }

  onJobChange(): void {
    this.loadExecutions(0);
  }

  onFilterChange(): void {
    this.loadExecutions(0);
  }

  formatDuration(ms: number | null): string {
    if (ms == null) return '—';
    if (ms < 1000) return `${ms}ms`;
    if (ms < 60000) return `${Math.round(ms / 1000)}s`;
    return `${Math.round(ms / 60000)}m`;
  }

  getStatusClass(status: string): string {
    switch (status) {
      case 'SUCCESS':
        return 'bg-green-100 text-green-700 dark:bg-green-500/10 dark:text-green-400';
      case 'FAILED':
        return 'bg-red-100 text-red-700 dark:bg-red-500/10 dark:text-red-400';
      case 'RUNNING':
        return 'bg-yellow-100 text-yellow-700 dark:bg-yellow-500/10 dark:text-yellow-400';
      default:
        return 'bg-gray-100 text-gray-600 dark:bg-gray-500/10 dark:text-gray-400';
    }
  }

  getStatusLabel(status: string): string {
    return scheduledJobExecutionStatusLabel(status);
  }

  truncate(text: string, max = 50): string {
    if (!text) return '';
    return text.length > max ? text.substring(0, max) + '…' : text;
  }
}
